(() => {
  const configElement = document.getElementById('lacey-brand-routing');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  if (window.location.hostname !== config.host) return;

  const current = new URL(window.location.href);
  const root = config.root.replace(/\/$/, '');
  const landing = new URL(config.landing, current.origin);
  if (landing.origin !== current.origin) return;

  const inEditor = config.designMode || config.visualPreviewMode || window.Shopify?.designMode || window.self !== window.top;
  const isBrandRoot = config.isHome && current.pathname.replace(/\/$/, '') === root;
  const needsTemplate = current.pathname.replace(/\/$/, '') === landing.pathname.replace(/\/$/, '') &&
    landing.searchParams.has('view') && !current.searchParams.has('view');
  if (!inEditor && (isBrandRoot || needsTemplate)) {
    const destination = new URL(current.href);
    destination.pathname = landing.pathname;
    for (const [key, value] of landing.searchParams) {
      if (!destination.searchParams.has(key)) destination.searchParams.set(key, value);
    }
    window.location.replace(destination.href);
    return;
  }

  const previewParameters = ['preview_theme_id', '_ab', '_fd', '_sc', 'pb'];
  const primaryHosts = new Set([config.primaryHost, 'laceyshares.com', 'www.laceyshares.com']);
  const storefrontPath = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:products|collections|pages|blogs|search|cart|policies)(?:\/|$)/;

  const updateLink = (link) => {
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#') || link.hasAttribute('download')) return;
    let url;
    try { url = new URL(href, current.href); } catch { return; }
    if (!['http:', 'https:'].includes(url.protocol)) return;
    const allBrands = link.hasAttribute('data-lacey-all-brands');
    const home = url.pathname.replace(/\/$/, '') === root;
    if (!allBrands && primaryHosts.has(url.hostname) && (home || storefrontPath.test(url.pathname))) {
      url.host = current.host;
      url.protocol = current.protocol;
    }
    if (url.origin === current.origin && (home || link.hasAttribute('data-lacey-brand-home'))) {
      url.pathname = landing.pathname;
    }
    if (url.origin === current.origin && url.pathname.replace(/\/$/, '') === landing.pathname.replace(/\/$/, '')) {
      for (const [key, value] of landing.searchParams) {
        if (!url.searchParams.has(key)) url.searchParams.set(key, value);
      }
    }
    if ((url.origin === current.origin && (home || storefrontPath.test(url.pathname))) || allBrands) {
      for (const key of previewParameters) {
        if (current.searchParams.has(key) && !url.searchParams.has(key)) {
          url.searchParams.set(key, current.searchParams.get(key));
        }
      }
      if (url.href !== new URL(href, current.href).href) link.href = url.href;
    }
  };

  const updateLinks = () => document.querySelectorAll('a[href]').forEach(updateLink);
  updateLinks();
  document.addEventListener('shopify:section:load', updateLinks);
  for (const eventName of ['click', 'auxclick']) {
    document.addEventListener(eventName, (event) => {
      const link = event.target.closest?.('a[href]');
      if (link) updateLink(link);
    }, true);
  }
})();
